<template>
    <div>
        <template v-if="data.expectedNumberOfAudioSeconds">

            <span ref="trigger"> {{ formatSecondsAsDuration(data.expectedNumberOfAudioSeconds) }} </span>
            <b-popover :target="popoverTarget" triggers="hover" @show="onPopoverShow" @hide="onPopoverHide" placement="left" :boundary="getBoundary">

                <b-skeleton-wrapper :loading="!workItemProgress">
                    <template #loading>
                        <b-skeleton></b-skeleton>
                        <b-skeleton></b-skeleton>
                        <b-skeleton></b-skeleton>
                    </template>

                    <b-tabs content-class="mt-3" v-if="workItemProgress">
                        <b-tab title="My progress" v-if="workItemProgress.myProgress">
                            <b-list-group>
                                <b-list-group-item>
                                    <h6>Turns</h6>
                                    Number of turns: <span class="float-right">{{ workItemProgress.myProgress.totalTurnCount }}</span><br />
                                    Completed turns: <span class="float-right">{{ workItemProgress.myProgress.completedTurnCount }}</span><br />
                                    Turns in progress: <span class="float-right">{{ workItemProgress.myProgress.inProgressTurnCount }}</span><br />
                                    Pre assigned turns: <span class="float-right">{{ workItemProgress.myProgress.preAssignedTurnCount }}</span>
                                </b-list-group-item>

                                <b-list-group-item>
                                    <h6>Audio</h6>
                                    Total audio: <span class="float-right">{{ formatSecondsAsDuration(workItemProgress.myProgress.totalAudioSeconds) }}</span><br />
                                    Completed audio: <span class="float-right">{{ formatSecondsAsDuration(workItemProgress.myProgress.completedAudioSeconds) }}</span><br />
                                    In progress audio: <span class="float-right">{{ formatSecondsAsDuration(workItemProgress.myProgress.inProgressAudioSeconds) }}</span><br />
                                    Pre assigned audio: <span class="ml-3 float-right">{{ formatSecondsAsDuration(workItemProgress.myProgress.preAssignedAudioSeconds) }}</span>
                                </b-list-group-item>

                                <b-list-group-item>
                                    <h6>Progress %</h6>
                                    <b-progress :value="workItemProgress.myProgress.progress" max="100" show-progress label="%" variant="info"></b-progress>
                                </b-list-group-item>

                                <b-list-group-item variant="dark" class="text-center">
                                    <span class="smaller">Time stamp: {{ formatDateTime(startTimeStamp, 'HH:mm:ss') }}</span>
                                    <b-link class="" @click="loadWorkItemProgress()">
                                        <b-icon icon="arrow-clockwise" variant="secondary" class="ml-2" font-scale="1"></b-icon>
                                    </b-link>
                                </b-list-group-item>

                            </b-list-group>
                        </b-tab>
                        <b-tab title="All progress" v-if="workItemProgress.overallProgress">
                            <b-list-group>
                                <b-list-group-item>
                                    <h6>Turns</h6>
                                    Number of turns: <span class="float-right">{{ workItemProgress.overallProgress.totalTurnCount }}</span><br />
                                    Completed turns: <span class="float-right">{{ workItemProgress.overallProgress.completedTurnCount }}</span><br />
                                    Turns in progress: <span class="float-right">{{ workItemProgress.overallProgress.inProgressTurnCount }}</span><br />
                                    Pre assigned turns: <span class="float-right">{{ workItemProgress.overallProgress.preAssignedTurnCount }}</span>
                                </b-list-group-item>

                                <b-list-group-item>
                                    <h6>Audio</h6>
                                    Total audio: <span class="float-right">{{ formatSecondsAsDuration(workItemProgress.overallProgress.totalAudioSeconds) }}</span><br />
                                    Completed audio: <span class="float-right">{{ formatSecondsAsDuration(workItemProgress.overallProgress.completedAudioSeconds) }}</span><br />
                                    In progress audio: <span class="float-right">{{ formatSecondsAsDuration(workItemProgress.overallProgress.inProgressAudioSeconds) }}</span><br />
                                    Pre assigned audio: <span class="ml-3 float-right">{{ formatSecondsAsDuration(workItemProgress.overallProgress.preAssignedAudioSeconds) }}</span>
                                </b-list-group-item>

                                <b-list-group-item>
                                    <h6>Progress %</h6>
                                    <b-progress :value="workItemProgress.overallProgress.progress" max="100" show-progress variant="info"></b-progress>
                                </b-list-group-item>

                                <b-list-group-item variant="dark" class="text-center">
                                    <span class="smaller">Time stamp: {{ formatDateTime(startTimeStamp, 'HH:mm:ss') }}</span>
                                    <b-link class="" @click="loadWorkItemProgress()">
                                        <b-icon icon="arrow-clockwise" variant="secondary" class="ml-2" font-scale="1"></b-icon>
                                    </b-link>
                                </b-list-group-item>

                            </b-list-group>
                        </b-tab>
                    </b-tabs>
                </b-skeleton-wrapper>
            </b-popover>
        </template>
    </div>
</template>

<script>

    import axios from 'axios';
    import DateTimeMixin from '../../mixins/DateTimeMixin';
    import ErrorsMixin from '../../mixins/ErrorsMixin';
    // import Visibility from 'visibilityjs';

    export default {

        name: 'AudioLengthColumnTemplate',
        mixins: [ErrorsMixin, DateTimeMixin],
        data: function () {
            return {
                data: null,
                workItemProgress: null,
                // timer: null,
                startTimeStamp: null,
                reloadInterval: 60000 // in ms
            };
        },

        computed: {

            getBoundary: function () {
                var boundary = document.getElementById('contentWrapper');
                return boundary;
            }
        },

        methods: {

            popoverTarget: function () {
                return this.$refs.trigger;
            },

            onPopoverShow: function () {
                if (this.workItemProgress === null || this.isTimeStampOutdated(this.reloadInterval)) { 
                    console.log('outdated || null:  callr: loadWorkItemProgress')
                    this.loadWorkItemProgress();
                    // this.timer = null;
                    // this.timer = Visibility.every(this.reloadInterval, this.loadWorkItemProgress);
                }
            },

            isTimeStampOutdated: function (interval) {

                var nowTimeStamp = new Date();
                var timeDiff = nowTimeStamp - this.startTimeStamp; //in ms
                // strip the ms
                timeDiff /= 1000;
                // ... and round to seconds 
                timeDiff = Math.round(timeDiff);
                
                if (timeDiff > interval) return true;
                else return false;
            },

            onPopoverHide: function () {
                
            }, 

            loadWorkItemProgress: function () {

                var url = this.$urlHelper.getApiUrl('workitem', 'progress', [this.data.workItemId]);
                axios
                    .get(url)
                    .then(response => {
                        this.workItemProgress = response.data;
                        this.startTimeStamp = new Date();
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            }
        }
    }
</script>